import { addLastPrefixEN } from '../transforms/addLastPrefix';
import { formatOrdinalEN } from '../transforms/formatOrdinal';
import { overrideBaseLocale } from './base-config';
export var enES = overrideBaseLocale('en-ES', {
    dayOfMonthOrdinal: {
        options: {
            day: 'numeric',
        },
        transforms: [formatOrdinalEN],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixEN],
    },
    time: {
        options: {
            timeStyle: 'short',
            hourCycle: 'h23',
        },
    },
});
//# sourceMappingURL=en-ES.js.map